export default function pdfPreview(): void {
  const pdfElements = document.querySelectorAll(".js-pdf-preview");

  Array.prototype.forEach.call(pdfElements, (element: HTMLInputElement) => {
    element.addEventListener("change", (event) => {
      const target = event.target as HTMLInputElement;
      if (!(target instanceof HTMLInputElement)) return;

      const file = target.files?.[0];
      if (!file || file.type !== "application/pdf") {
        alert("PDFファイルのみアップロード可能です。");
        target.value = ""; // 選択されたファイルをリセット
        return;
      }

      const parent = element.closest(".file-upload__item");
      if (!(parent && parent instanceof HTMLElement)) return;

      const filenameElement = parent.querySelector(".term-filename");
      if (!(filenameElement && filenameElement instanceof HTMLElement)) return;

      // 利用規約のプレビューを初期化
      filenameElement.innerHTML = "";

      // 選択した利用規約のURLを生成
      const objectUrl = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.textContent = file.name;
      link.href = objectUrl;
      link.target = "_blank";
      filenameElement.appendChild(link);

      // メモリリーク防止のためのクリーンアップ
      element.addEventListener("change", () => {
        URL.revokeObjectURL(objectUrl);
      }, { once: true });
    });
  });
}
